import { useEffect, useRef, useState } from "react";

import styles from "../../../../styles/test-shooting-card.module.css";
import { Button } from "../../../components/Button";
import { If } from "../../../components/control-statements";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";

import {
  TestShootingAPI,
  TestShootingSmsBody,
} from "../../../../providers/TestShootingAPI";

export const TestShootingCard = ({
  sender = "",
  message,
  url,
  beneficio,
  valorrecebido,
}) => {
  const [remainTime, setRemainTime] = useState(0);
  const [isWaitingSending, setIsWaitingSending] = useState(false);
  const [testPhone, setTestPhone] = useState({ ddd: "55", phone: "" });
  const [validPhone, setValidPhone] = useState(false);

  const phoneRef = useRef(null);

  const validMessage = () => {
    return message && message.length > 0;
  };

  const sendSmsTest = async () => {
    setIsWaitingSending(true);
    const response = await TestShootingAPI.postSms(
      new TestShootingSmsBody({
        phone: `${testPhone.ddd}${testPhone.phone.replace(/[^\d+]/g, "")}`,
        message: `${sender}${message}`,
        replacements: { url, beneficio, valorrecebido },
      })
    );

    if (response.getCode(500) != 200) {
      alert({ text: "Ocorreu um erro ao disparar a mensagem de teste" });
      setIsWaitingSending(false);
      return;
    }

    const startTimer = () => {
      let startTime = 180;
      const intervalId = setInterval(() => {
        setRemainTime(startTime--);
        if (startTime == 0) {
          clearInterval(intervalId);
          setIsWaitingSending(false);
        }
      }, 1000);
    };
    startTimer();
  };

  useEffect(() => {
    const phoneValid = testPhone.phone?.replace(/\D/g, "").length === 11;
    setValidPhone(phoneValid);
  }, [testPhone]);

  return (
    <div>
      <Label text="Disparo teste" className={"mb-20"} />
      <p className={styles["enter-phone"]}>
        Informe o seu número de telefone para que possamos realizar um disparo
        teste.
      </p>

      <div className={styles["fire-test-message"]}>
        <div className="d-flex mb-25 justify-center">
          <Input
            design="one"
            center
            disabled={isWaitingSending}
            value={testPhone.phone}
            placeholder="00000-0000"
            mask="(99) 99999-9999"
            className="w-100"
            onChange={(e) => {
              setTestPhone({
                ...testPhone,
                phone: e.target.value,
              });
            }}
          />
        </div>
        <Button
          design="four"
          className="w-100"
          disabled={isWaitingSending || !validMessage() || !validPhone}
          onClick={sendSmsTest}
        >
          Disparar
          <If cond={remainTime > 0}>
            <span>
              &nbsp;(
              {`${`${Math.floor(remainTime / 60)}`.padStart(2, "0")}:${`${
                remainTime % 60
              }`.padStart(2, "0")}`}
              )
            </span>
          </If>
        </Button>
      </div>
    </div>
  );
};
